module.exports = __webpack_public_path__ + "img/highlighter.9b1805.svg";